import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import axios from 'axios'

const FreePerksEditComponent = props => {
  const { item } = props.location.state

  const [data, setData] = useState({
    koTitle: item.title_ko
      ? item.title_ko
      : item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ko')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ko')[0].title
        : ''
      : '',
    jaTitle: item.title_ja
      ? item.title_ja
      : item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ja')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ja')[0].title
        : ''
      : '',
    enTitle: item.title_en
      ? item.title_en
      : item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'en')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'en')[0].title
        : ''
      : '',
    ruTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ru')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ru')[0].title
        : ''
      : '',
    ptTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'pt')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'pt')[0].title
        : ''
      : '',
    esTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'es')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'es')[0].title
        : ''
      : '',
    idTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'id')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'id')[0].title
        : ''
      : '',
    zhTWTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'zh-TW')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'zh-TW')[0].title
        : ''
      : '',
    msTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ms')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ms')[0].title
        : ''
      : '',
    viTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'vi')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'vi')[0].title
        : ''
      : '',
    arTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ar')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ar')[0].title
        : ''
      : '',
    hiTitle: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'hi')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'hi')[0].title
        : ''
      : '',
    koDescription: item.description_ko ? item.description_ko : '',
    jaDescription: item.description_ja ? item.description_ja : '',
    enDescription: item.description_en ? item.description_en : '',
    ruDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ru')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ru')[0].description
        : ''
      : '',
    ptDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'pt')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'pt')[0].description
        : ''
      : '',
    esDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'es')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'es')[0].description
        : ''
      : '',
    idDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'id')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'id')[0].description
        : ''
      : '',
    zhTWDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'zh-TW')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'zh-TW')[0].description
        : ''
      : '',
    msDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ms')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ms')[0].description
        : ''
      : '',
    viDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'vi')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'vi')[0].description
        : ''
      : '',
    arDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'ar')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'ar')[0].description
        : ''
      : '',
    hiDescription: item.onboardingInfo
      ? item.onboardingInfo.filter(o => o.lang === 'hi')[0]
        ? item.onboardingInfo.filter(o => o.lang === 'hi')[0].description
        : ''
      : '',
    img: item.img ? item.img : '',
    coin: item.coin ? item.coin : 0,
    maxCount: item.maxCount ? item.maxCount : 1,
    keyword: item.keyword ? item.keyword : '',
    status: item.status ? item.status : 'Y',
    ios: item.ios ? item.ios : 'Y',
    android: item.android ? item.android : 'Y',
  })

  const [uploadFile, setUploadFile] = useState(null)

  const clickSave = async () => {
    const formData = new FormData()

    formData.append('koTitle', data.koTitle)
    formData.append('jaTitle', data.jaTitle)
    formData.append('enTitle', data.enTitle)
    formData.append('ruTitle', data.ruTitle)
    formData.append('ptTitle', data.ptTitle)
    formData.append('esTitle', data.esTitle)
    formData.append('idTitle', data.idTitle)
    formData.append('zhTWTitle', data.zhTWTitle)
    formData.append('msTitle', data.msTitle)
    formData.append('viTitle', data.viTitle)
    formData.append('arTitle', data.arTitle)
    formData.append('hiTitle', data.hiTitle)
    formData.append('koDescription', data.koDescription)
    formData.append('jaDescription', data.jaDescription)
    formData.append('enDescription', data.enDescription)
    formData.append('ruDescription', data.ruDescription)
    formData.append('ptDescription', data.ptDescription)
    formData.append('esDescription', data.esDescription)
    formData.append('idDescription', data.idDescription)
    formData.append('zhTWDescription', data.zhTWDescription)
    formData.append('msDescription', data.msDescription)
    formData.append('viDescription', data.viDescription)
    formData.append('arDescription', data.arDescription)
    formData.append('hiDescription', data.hiDescription)
    formData.append('coin', data.coin)
    formData.append('maxCount', data.maxCount)
    formData.append('keyword', data.keyword)
    formData.append('status', data.status)
    formData.append('ios', data.ios)
    formData.append('android', data.android)
    if (item.seq) {
      formData.append('id', item.seq)
    }
    if (uploadFile) {
      formData.append('img', uploadFile)
    }

    await axios
      .post(`/new/webAdmin/v2/perks/onboarding`, formData, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(() => {
        props.history.goBack()
      })
  }

  return (
    <Wrapper>
      <Title>Title (제목)</Title>
      <div
        style={{
          width: '100%',
          display: 'grid',
          columnGap: '5px',
          gridTemplateColumns: 'repeat(4, 1fr)',
        }}
      >
        <div style={{ width: '100%' }}>
          <div>ja</div>
          <input
            type="text"
            value={data.jaTitle}
            onChange={e => setData({ ...data, jaTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ko</div>
          <input
            type="text"
            value={data.koTitle}
            onChange={e => setData({ ...data, koTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>en</div>
          <input
            type="text"
            value={data.enTitle}
            onChange={e => setData({ ...data, enTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ru</div>
          <input
            type="text"
            value={data.ruTitle}
            onChange={e => setData({ ...data, ruTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>pt</div>
          <input
            type="text"
            value={data.ptTitle}
            onChange={e => setData({ ...data, ptTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>es</div>
          <input
            type="text"
            value={data.esTitle}
            onChange={e => setData({ ...data, esTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>id</div>
          <input
            type="text"
            value={data.idTitle}
            onChange={e => setData({ ...data, idTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>zh-TW</div>
          <input
            type="text"
            value={data.zhTWTitle}
            onChange={e => setData({ ...data, zhTWTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ms</div>
          <input
            type="text"
            value={data.msTitle}
            onChange={e => setData({ ...data, msTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>vi</div>
          <input
            type="text"
            value={data.viTitle}
            onChange={e => setData({ ...data, viTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ar</div>
          <input
            type="text"
            value={data.arTitle}
            onChange={e => setData({ ...data, arTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>hi</div>
          <input
            type="text"
            value={data.hiTitle}
            onChange={e => setData({ ...data, hiTitle: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <Title>Description (설명)</Title>
      <div
        style={{
          width: '100%',
          display: 'grid',
          columnGap: '5px',
          gridTemplateColumns: 'repeat(2, 1fr)',
        }}
      >
        <div style={{ width: '100%' }}>
          <div>ja</div>
          <input
            type="text"
            value={data.jaDescription}
            onChange={e => setData({ ...data, jaDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ko</div>
          <input
            type="text"
            value={data.koDescription}
            onChange={e => setData({ ...data, koDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>en</div>
          <input
            type="text"
            value={data.enDescription}
            onChange={e => setData({ ...data, enDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ru</div>
          <input
            type="text"
            value={data.ruDescription}
            onChange={e => setData({ ...data, ruDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>pt</div>
          <input
            type="text"
            value={data.ptDescription}
            onChange={e => setData({ ...data, ptDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>es</div>
          <input
            type="text"
            value={data.esDescription}
            onChange={e => setData({ ...data, esDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>id</div>
          <input
            type="text"
            value={data.idDescription}
            onChange={e => setData({ ...data, idDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>zh-TW</div>
          <input
            type="text"
            value={data.zhTWDescription}
            onChange={e =>
              setData({ ...data, zhTWDescription: e.target.value })
            }
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ms</div>
          <input
            type="text"
            value={data.msDescription}
            onChange={e => setData({ ...data, msDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>vi</div>
          <input
            type="text"
            value={data.viDescription}
            onChange={e => setData({ ...data, viDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>ar</div>
          <input
            type="text"
            value={data.arDescription}
            onChange={e => setData({ ...data, arDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ width: '100%' }}>
          <div>hi</div>
          <input
            type="text"
            value={data.hiDescription}
            onChange={e => setData({ ...data, hiDescription: e.target.value })}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <Title>Image (이미지)</Title>
      <div>
        <img
          src={uploadFile ? URL.createObjectURL(uploadFile) : item.img}
          alt=""
          style={{ width: '160px', height: '102px', borderRadius: '12px' }}
        />
      </div>
      <input
        type="file"
        multiple={false}
        onChange={e => {
          if (e.target.files && e.target.files[0]) {
            setUploadFile(e.target.files[0])
          }
        }}
      />
      <Title>Coin (지급 코인)</Title>
      <input
        type="number"
        value={data.coin}
        onChange={e => setData({ ...data, coin: e.target.value })}
      />
      <Title>Max Count (최대 지급 횟수)</Title>
      <input
        type="number"
        value={data.maxCount}
        onChange={e => setData({ ...data, maxCount: e.target.value })}
      />
      <Title>Keyword (조건 키워드)</Title>
      <input
        type="text"
        value={data.keyword}
        onChange={e => setData({ ...data, keyword: e.target.value })}
      />
      <div style={{ display: 'flex' }}>
        <div style={{ width: '100%' }}>
          <Title>Status (상태)</Title>
          <select
            value={data.status}
            onChange={e => {
              setData({
                ...data,
                status: e.target.value,
                ios: e.target.value === 'N' ? e.target.value : data.ios,
                android: e.target.value === 'N' ? e.target.value : data.android,
              })
            }}
            style={{ width: '100%' }}
          >
            <option value="Y">Y</option>
            <option value="N">N</option>
          </select>
        </div>
        <div style={{ width: '100%' }}>
          <Title>iOS</Title>
          <select
            value={data.ios}
            onChange={e => setData({ ...data, ios: e.target.value })}
            style={{ width: '100%' }}
          >
            <option value="Y">Y</option>
            <option value="N">N</option>
          </select>
        </div>
        <div style={{ width: '100%' }}>
          <Title>Android</Title>
          <select
            value={data.android}
            onChange={e => setData({ ...data, android: e.target.value })}
            style={{ width: '100%' }}
          >
            <option value="Y">Y</option>
            <option value="N">N</option>
          </select>
        </div>
      </div>

      <ButtonWrapper>
        <button
          style={{ backgroundColor: '#007ffb' }}
          onClick={() => {
            clickSave()
          }}
        >
          저장
        </button>
        <button
          style={{ backgroundColor: '#dc143c' }}
          onClick={() => {
            props.history.goBack()
          }}
        >
          취소
        </button>
      </ButtonWrapper>
    </Wrapper>
  )
}

export default withRouter(FreePerksEditComponent)

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  font-size: 20px;
  margin-top: 10px;
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-left: 10px;
    color: #fff;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }
`
